import $ from 'jquery';
import Timer from '../../tnew/lib/Timer';
import Messaging from '../../tnew/ui/Messaging';
import CartTimerService from './CartTimerService';
import CartExpiredModal from './CartExpiredModal';


function setErrorMessage(message) {
  Messaging.clear();
  Messaging.addError(message, true);
}


class TimerHandler {
  constructor() {
    this.secondsRemaining = null;
    this.timer = null;
  }

  initialize() {
    $(() => {
      this.$container = $('.tn-timer');

      this.$countdown = this.$container.find('.tn-count-down-timer');

      const isCartTimed = !!this.$container.attr('data-tn-is-cart-timed');

      if (isCartTimed) {
        const milliseconds = Number.parseFloat(this.$countdown.attr('data-tn-milliseconds-remaining'));

        this.setTimeRemaining(milliseconds);
      }
    });
  }

  setTimeRemaining(milliseconds) {
    if (this.timer === null) {
      this.timer = new Timer({
        milliseconds,
        update: this.onUpdate,
        complete: this.onComplete,
      });
    }

    this.timer.restart(milliseconds);

    $('.tn-cart-link').addClass('tn-active');

    this.$container.show();
  }

  onUpdate = (formattedTimeRemaining, secondsRemaining) => {
    if (secondsRemaining === this.secondsRemaining) {
      return;
    }

    window.requestAnimationFrame(() => {
      const isUrgent = this.timer.isUrgent(secondsRemaining);

      this.$container.toggleClass('tn-timer-urgent', isUrgent);

      this.secondsRemaining = secondsRemaining;

      this.$countdown.text(formattedTimeRemaining);
    });
  }

  transferSession = async () => {
    try {
      await CartTimerService.transferSession();
    } catch (error) {
      setErrorMessage('There was an error clearing the cart');

      return;
    }

    CartExpiredModal.open();
  }

  onComplete = async () => {
    let millisecondsRemaining;

    try {
      const response = await CartTimerService.getTimeRemaining();
      millisecondsRemaining = response.millisecondsRemaining;
    } catch (error) {
      setErrorMessage('There was an error updating the cart timer');

      return;
    }

    if (millisecondsRemaining <= 0) {
      this.transferSession();
    } else {
      this.setTimeRemaining(millisecondsRemaining);
    }
  }
}


export default TimerHandler;



// WEBPACK FOOTER //
// ./V7/cart/timer/TimerHandler.js